import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DialogConfirm, DialogConfirmData } from 'app/dialogs/confirm/dialog-confirm';
import { ExposedListJobsRes } from 'app/interfaces/responses/Exposed/exposedListJobsRes';
import { JobsService } from 'app/services/api/queue/jobs.service';
import { TranslationService } from 'app/services/api/translation/translation.service';
import { JOB_STATUS, JOB_STATUS_TRANSLATIONS, JOB_TYPES } from 'common/constants/queue.constants';
import { Subscription, interval } from 'rxjs';

@Component({
    selector: 'documents-jobs',
    templateUrl: './documents-jobs.component.html',
})
export class DocumentsJobsComponent implements OnInit {
    @ViewChild('tablePaginator ') displayedDataPaginator: MatPaginator;
    dataSource: MatTableDataSource<ExposedListJobsRes> = new MatTableDataSource<ExposedListJobsRes>();
    displayedColumns: string[] = ['id', 'name', 'created_at', 'status', 'actions'];
    dataReloadSubscription: Subscription;
    pageSize: number = 25;
    allJobs: ExposedListJobsRes[] = [];
    jobStatus = JOB_STATUS;
    loading: boolean = false;

    constructor(
        private jobsService: JobsService,
        private translationService: TranslationService,
        private dialog: MatDialog
    ) {}

    ngOnInit(): void {
        this.fetchJobs(true);
        this.dataReloadSubscription = interval(10 * 1000).subscribe(() => {
            if (!this.loading) {
                this.fetchJobs(false);
            }
        });
    }

    ngAfterViewInit(): void {
        this.dataSource.paginator = this.displayedDataPaginator;
    }

    ngOnDestroy(): void {
        this.dataReloadSubscription.unsubscribe();
    }

    fetchJobs = (showLoader: boolean) => {
        this.loading = true;
        this.jobsService.getJobs([JOB_TYPES.DOCUMENT_TEMPLATE_GROUP_UPLOAD, JOB_TYPES.DOCUMENT_FILE_GROUP_UPLOAD], showLoader).subscribe({
            next: (res) => {
                this.allJobs = res;
                this.dataSource.data = res;
                this.loading = false;
            },
            error: () => {
                this.loading = false;
            },
        });
    };

    getStatusMessage = (item: ExposedListJobsRes) => {
        let statusLabel = JOB_STATUS_TRANSLATIONS[item.status];
        let message = `${this.translationService.translate(statusLabel)}`;
        if (item.status == JOB_STATUS.PROCESSING) {
            message += ` (${item.numSuccessfulMessages + item.numFailedMessages}/${item.numMessages})`;
        } else if (item.status == JOB_STATUS.FINISHED_WITH_FAILURES) {
            message += ` (${item.numFailedMessages})`;
        }
        return message;
    };

    getStatusTooltip = (item: ExposedListJobsRes) => {
        return `Stöður skjala í vinnslu:\nÍ bið:\t${item.numQueuedMessages}\nÍ vinnslu:\t${item.numProcessingMessages}\nVilla:\t${item.numFailedMessages}\nTókst:\t${item.numSuccessfulMessages}`;
    };

    getDocumentJobDisplayName = (item: ExposedListJobsRes) => {
        return item.displayName ?? this.translationService.translate('label_documents_jobs') + ` ${item.id}`;
    };

    onRerunFailedJobs = (item: ExposedListJobsRes) => {
        const dialogRef = this.dialog.open(DialogConfirm, {
            autoFocus: false,
            restoreFocus: false,
            width: '450px',
            disableClose: true,
            data: {
                title: this.translationService.translate('label_confirm_action'),
                message: this.translationService.translate('text_confirm_retry_document_job_messages'),
            } as DialogConfirmData,
        });

        dialogRef.afterClosed().subscribe((confirm: boolean) => {
            if (confirm) {
                this.jobsService.rerunFailedJobMessages(item.id);
            }
        });
    };
}
